module.exports = __webpack_public_path__ + "static/media/full_1.7f75a355.jpg";